/**
 * The one queue every template thumbnail asks through (thumb-queue.ts), and
 * its forgetting on sign-out: a thumbnail prints under its viewer's mask, so
 * none outlives the session that drew it.
 */
import { DocRefused } from './doc-api';
import { makeThumbQueue } from './thumb-queue';

/** Two at a time, of the renderer's 4 waiters (D27), leaving room for issues and the open preview. */
export const thumbs = makeThumbQueue<string>({
  lanes: 2,
  tries: 4,
  isBusy: (thrown) => thrown instanceof DocRefused && thrown.status === 503,
  wait: (ms) => new Promise((done) => setTimeout(done, ms)),
  now: () => Date.now(),
  keepMs: 60_000,
});

/** Drops every page kept: on sign-out, so the next person to sign in in this tab draws their own. */
export const forgetThumbs = (): void => thumbs.forget();
